<template>
    <v-autocomplete
      v-model="value"
      cache-items
      dense
      :small-chips="smallChips"
      :deletable-chips="deletableChips"
      hide-selected
      :items="itemsList"
      :search-input.sync="searchItem"
      open-on-clear
      item-value="familia"
      item-text="familia"
      outlined
      no-data-text="Introduzca texto a buscar"
      :label="label"
      :readonly="readonly"
      return-object
      ref="FindCtrl"
      :clearable="!readonly"
      :multiple="multiple"
      :menu-props="{'open-on-click': true}"
      @click="clickEvt"
      @click:append="clickAppendEvt"
      @input="inputEvt"
      @change="changeEvt"
      @blur="blurEvt"
      @update:search-input="updateSearchInputEvt"
    ></v-autocomplete>
</template>

<script>
  import axios from "axios";
  import { mapState } from "vuex";
  export default {
    computed:{
        ...mapState(['empId', 'perId', 'urlRaiz'])
    },
    data: () => ({
      itemsList: [],
      searchItem: null,
    }),
    props: {
      value: { default: null },
      label: { type: String, default: '' },
      multiple: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false },
      smallChips: { type: Boolean, default: false },
      deletableChips: { type: Boolean, default: false },
      selectOnReadonly: { type: Boolean, default: false },
      dirId: { type: Number, default: null },
      fecha: { type: String, default: null },
      proveedor: { type: String, default: null },
      familiasExcluidas: { type: Array, default: () => [] }
    },
    watch: {
      searchItem(val) {
       this.loadItems(val);
      },
      dirId() {
        this.$refs.FindCtrl.cachedItems = [];
        this.loadItems();
      },
      fecha() {
        this.$refs.FindCtrl.cachedItems = [];
        this.loadItems();
      },
      proveedor() {
        this.$refs.FindCtrl.cachedItems = [];
        this.loadItems();
      },
      familiasExcluidas() {
        this.$refs.FindCtrl.cachedItems = [];
        this.loadItems();
      },
      value() {
        if (this.value != null && this.value != undefined && this.value != '') {
          this.loadItems();
        }
      }
    },
    methods: {
      loadItems(valFind) {
        var controllerParameters = {
            Search: valFind,
            EmpId: this.empId,
            DirId: this.dirId,
            FechaPedido: this.fecha,
            Proveedor: this.proveedor,
            FamiliasExcluidas: this.familiasExcluidas,
            NumRegsPag: 100,
            NumPag: 1
        };

      var valorActual = this.value;
      var AuthToken = localStorage.getItem('token'); 
       axios({ method: "POST", "url": this.urlRaiz + "/api/artprov/familia/list", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
       .then(result => {
            this.itemsList = result.data.EntsList;

            if(valorActual != null) { 
              if (!Array.isArray(valorActual)) {  // es un objeto
                if (valorActual.familia != null) {
                  if (!this.itemsList.some(itm=>itm.familia === valorActual.familia)) {
                    this.itemsList.push(valorActual);
                  }
                }
              }
              else {
                valorActual.forEach(element => {  // es un array
                  if (!this.itemsList.some(itm=>itm.familia === element.familia)) {
                    this.itemsList.push(element);
                  }
                });
              }
            }
        });
      },
      manageMenu(checkMenu) {
        if (checkMenu) {
          if (!this.$refs.FindCtrl.isMenuActive) {
            this.$refs.FindCtrl.isMenuActive = true;
          }
          else {
            this.$refs.FindCtrl.isMenuActive = false;
          }
        }
      },
      clickEvt() {
        const checkMenu = this.readonly && this.selectOnReadonly;
        this.manageMenu(checkMenu);
        this.$emit('click');
      },
      clickAppendEvt() {
        const checkMenu = !this.readonly || (this.readonly && this.selectOnReadonly);
        this.manageMenu(checkMenu);
        this.$refs.FindCtrl.focus();
        this.$emit('click-append');
      },
      inputEvt() {
        this.$emit('input', this.value);
      },
      changeEvt() {
        this.$emit('change', this.value);
      },
      blurEvt() {
        this.$emit('blur', this.value);
      },
      updateSearchInputEvt() {
        this.$emit('update:search-input', this.value)
      }
    },
    mounted() {
      this.itemsList = [];
      this.loadItems();
    }
  }
</script>